import { ROUTE_PATH_ALERTS, ROUTE_PATH_HOME,ROUTE_PATH_SCAM,ROUTE_PATH_IDENTITY, ROUTE_PATH_PROTECTION } from '../../constants';
import { SiteNavbarTranslations } from '../types';

export const translations: SiteNavbarTranslations = {
  menu: {
    home: {
      to: ROUTE_PATH_HOME,
      exact: true,
      children: 'Home'
    },
      ScamDetection: {
      to: ROUTE_PATH_SCAM,
      exact: true,
      children: 'Scam Detection'
    },
    monitoringAndAlerts: {
      to: ROUTE_PATH_ALERTS,
      exact: true,
      children: 'Monitoring & Alerts'
    },
    identityRestoration: {
      to: ROUTE_PATH_IDENTITY,
      exact: true,
      children: 'Identity Restoration'
    },
    lostWalletProtection: {
      to: ROUTE_PATH_PROTECTION,
      exact: true,
      children: 'Lost Wallet Protection'
    },
  }
};
